import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../plugins/custom_css/login.css";

const BASE_URI = process.env.REACT_APP_API_BASE_URI;

const LoginPage = ({ login, isAuthenticated }) => {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (isLoading) return;

    try {
      setIsLoading(true);
      setError("");

      const response = await axios.post(`${BASE_URI}/auth/login`, {
        email,
        password: pass,
      });

      const { token } = response.data;

      if (token) {
        login(token);
      } else {
        setError("Login failed. No token received.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Invalid credentials. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="login_form">
      <div className="box-form">
        <div className="left">
          <div className="overlay">
            <img src="/SS360_logo.jpg" alt="SS360" />
          </div>
        </div>

        <div className="right">
          <h5>Admin Login</h5>
          <p className="login-subtitle">Sign in to access the Smart Scholar 360 dashboard.</p>
          <div className="inputs">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
              autoComplete="email"
              required
            />
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={isLoading}
                required
              />
              <i
                className={`password-toggle-icon bi ${
                  showPassword ? "bi-eye-slash" : "bi-eye"
                }`}
                onClick={togglePasswordVisibility}
                title={showPassword ? "Hide password" : "Show password"}
              ></i>
            </div>
          </div>
          {error && <p className="error-message">{error}</p>}
          <button
            onClick={handleLogin}
            disabled={isLoading}
            className={isLoading ? "loading" : ""}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
